import React from 'react';
import FamilyFinancialWellbeing from '../components/FamilyFinancialWellbeing';

const FinancialWellbeingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <FamilyFinancialWellbeing />
    </div>
  );
};

export default FinancialWellbeingPage;